import {useInjex} from '@injex/react-plugin';
import CloudManager from '../managers/CloudManager.mdl';

export default function useCloudManager(): CloudManager {
    const [inject] = useInjex();
    return inject<CloudManager>('cloudManager');
}
